import { Button as MuiButton, CircularProgress } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { tokens } from '../../../theme'

export function Button({
  children,
  onClick,
  variant = 'primary',
  fullWidth = true,
  showArrow = true,
  disabled = false,
  loading = false,
  type = 'button',
}) {
  return (
    <MuiButton
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      variant={variant === 'primary' ? 'contained' : 'outlined'}
      endIcon={!loading && showArrow ? <ArrowForwardIcon /> : null}
      sx={{
        height: 56,
        borderRadius: 300,
        textTransform: 'none',
        fontSize: 18,
        fontWeight: 500,
        fontFamily: tokens.typography.fontFamily.body,
        ...(variant === 'primary' && {
          bgcolor: tokens.colors.primary.main,
          borderColor: tokens.colors.primary.main,
          '&:hover': {
            bgcolor: tokens.colors.primary.dark,
            borderColor: tokens.colors.primary.dark,
          },
        }),
        ...(variant === 'secondary' && {
          color: tokens.colors.primary.main,
          borderColor: tokens.colors.primary.main,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            bgcolor: 'rgba(80, 27, 192, 0.1)',
          },
        }),
      }}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : children}
    </MuiButton>
  )
}
